<template>
  <div class="ope-list-container">
    <!-- 显示前两个按钮 -->
    <el-button
      size="small"
      link
      style="
      margin: 0 !important;
      font-size: 12px !important;
      line-height: 15px !important;
      height: 15px !important;
      vertical-align: 3px !important;margin-right: 5px;"
      v-for="(obj, i) in visibleButtons"
      :key="i"
      :color="obj.color"
      :loading="obj.loading"
      :style="{
        color: obj.color,
      }"
      :title="obj.tips||''"
      v-show="showFn(obj)"
      @click="clickFn(obj)"
    >{{ obj.label }}</el-button>
    
    <!-- 更多按钮 -->
    <el-dropdown v-if="hasMoreButtons" trigger="click">
      <el-button
        size="small"
        link
        style="
        margin: 0 !important;
        font-size: 11px !important;
        color: #409eff;
        "
      >
        更多 <el-icon class="el-icon--right"><arrow-down /></el-icon>
      </el-button>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item
            v-for="(obj, i) in moreButtons"
            :key="i"
            :title="obj.tips||''"
            @click="clickFn(obj)"
          >
            {{ obj.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>
<script lang="ts" setup>
import { getCurrentInstance, onMounted, ref, computed } from "vue";
import { ElMessage } from "element-plus";
import comCueBox from "../comCue/comCue";
import { ArrowDown } from "@element-plus/icons-vue";

const buttonList = ref([]);
const vDom = getCurrentInstance();
const moreMode = ref(false);

onMounted(() => {
  moreMode.value = (vDom.proxy as any).params.showMoreMode || false;
  buttonList.value = (vDom.proxy as any).params.list.map(o => {
    o["loading"] = false;
    if (o?.type === "delete") {
      o["color"] = "red";
    }
     if (!o.hasOwnProperty("color")) {
      o["color"] = "#409eff";
    }
    return { ...o };
  }).filter(obj => showFn(obj));
});

// 计算可见按钮（前两个）
const visibleButtons = computed(() => {
  if (moreMode.value) {
    return buttonList.value.slice(0, 2);
  }
  return buttonList.value;
});

// 计算是否有更多按钮
const hasMoreButtons = computed(() => {
  if (!moreMode.value) {
    return false;
  }
  // 过滤掉不显示的按钮后再判断
  const visibleButtonsCount = buttonList.value.filter(obj => showFn(obj)).length;
  return visibleButtonsCount > 2;
});

// 计算更多按钮列表
const moreButtons = computed(() => {
  if (!moreMode.value) {
    return [];
  }
  return buttonList.value.slice(2).filter(obj => showFn(obj));
});

const tipsPro = s => {
  return new Promise(r => {
    comCueBox(`请确认执行【${s}】操作？`).then(() => {
      r(true);
    });
  });
};

const clickFn = async obj => {
  let flag = true;
  if (obj?.type === "delete") {
    flag = (await tipsPro(obj.label)) as boolean;
  }
  const data = (vDom.proxy as any).params.data;
  flag &&
    obj.onClick(data, s => {
      if (typeof s === "boolean") {
        obj.loading = s;
      } else {
        ElMessage.success(`${obj.label}成功！`);
        obj.loading = false;
      }
    });
};

// 控制操作列按钮显示隐藏
const showFn = obj => {
  if (!obj.show) {
    return true;
  }
  const data = (vDom.proxy as any).params.data;
  return obj.show(data);
};
</script>
<style scoped>
.ope-list-container {
  display: flex;
  align-items: center;
}
</style>